//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  components: {},
  mounted: function mounted() {
    window.bodymovin.loadAnimation({
      path: 'https://m.film.qq.com/vip-activity/kid-cny2021/lottie/lucky-bag/data.json',
      loop: true,
      autoplay: true,
      renderer: 'svg',
      // 渲染方式，有"html"、"canvas"和"svg"三种
      container: this.$refs.lottie_box
    });
  }
};